import { handleResponse, handleBlobResponse } from "utils/utils";
import { authService } from "services";

export const iPlanService = {
	updateMagicPlan,
	getPlanningParams,
	downloadSalesTemplate,
	salesForecast,
	staffingLevelsForecast,
	cancelIntelligentPlanning,
};

function updateMagicPlan(iplan) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
		body: JSON.stringify(iplan),
	};

	return fetch(
		`${global.BASE_API}intelligent-planning/assignments`,
		//`https://plan.plain.ninja/saas/api/intelligent-planning/assignments`,
		requestOptions
	).then(handleResponse);
}

function getPlanningParams(groupId) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
	};

	return fetch(
		`${global.BASE_API}intelligent-planning/params/${encodeURIComponent(groupId)}`,
		requestOptions
	).then(handleResponse);
}

function downloadSalesTemplate() {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
	};

	return fetch(
		`${global.BASE_API}intelligent-forecast/sales-forecast/template`,
		requestOptions
	).then(handleBlobResponse);
}

function salesForecast(formData) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
		body: formData,
	};

	return fetch(
		`${global.BASE_API}intelligent-forecast/sales-forecast`,
		requestOptions
	).then(handleResponse);
}

function staffingLevelsForecast(formData) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
		},
		body: formData,
	};

	return fetch(
		`${global.BASE_API}intelligent-forecast/staffing-levels`,
		requestOptions
	).then(handleResponse);
}

function cancelIntelligentPlanning(id) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: `Bearer ${authService.token.access_token}`,
			"Content-Type": "application/json",
		},
	};

	return fetch(
		`${global.BASE_API}intelligent-planning/plan-calculation/${id}/cancel`,
		requestOptions
	).then(handleResponse);
}
